import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ProcessFlowsHomepage } from 'pages/processFlows/ProcessFlowsHomepage'

export const Route = createFileRoute('/process-flows/{-$siteID}/')({
  component: ProcessFlowsRouteComponent,
  staticData: {
    title: 'Process Flows',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: true,
    },
  },
})

function ProcessFlowsRouteComponent() {
  const params = Route.useParams()
  const siteID = params.siteID

  if (!siteID) {
    return <Outlet />
  }

  return <ProcessFlowsHomepage />
}
